export const ACTION = {
  ADD_QUERY_PARAM: 'REMOTE_DATA:ADD_QUERY_PARAM'
};

export class AddQueryParam {
  public type: string = ACTION.ADD_QUERY_PARAM;
  constructor(public queryParam: string, public value: string) {}
}
